import React from "react";

const Footer = () => {
  return (
    <footer>
      <div>
        <h1>OUT-OF-BOX</h1>
        <p> &copy; all right reserved</p>
      </div>

      <div>
        <h5>Follow Us</h5>
        <div>
          <a href="https://youtube.com" target={"blank"}>
            Youtube_
          </a>
          <a href="https://instagram.com" target={"blank"}>
            Instagram_
          </a>
          <a href="https://github.com" target={"blank"}>
            Github
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
